import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const RoleToolbar = props => {
  const { className, canCreate, ...rest } = props;
  const { langRolePrivilege} = useSelector((state) => state.locale);
  const classes = useStyles();
  const history = useHistory();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.title}
          variant="h2"
        >
          {langRolePrivilege.titlePageHeading}
        </Typography>
        <span className={classes.spacer} />
        {/* <Button className={classes.importButton}>Import</Button>
        <Button className={classes.exportButton}>Export</Button> */}
        {canCreate === "true"? 
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push('/roles/new')}
          >
            {langRolePrivilege.actionNewRole}
          </Button>
        : null}
      </div>
      {/* <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search user"
        />
      </div> */}
    </div>
  );
};

RoleToolbar.propTypes = {
  className: PropTypes.string,
  canCreate: PropTypes.string,
};

export default RoleToolbar;
